import { Logo } from './Logo.js';

/**
 * Waiting, said calmly: the mark, a turning ring, a few words. Used wherever
 * the app is opening, signing in, or fetching its first figures, so the wait
 * looks the same everywhere and nothing snaps into place.
 */
export function Loading({ text = 'One moment.' }: { text?: string }) {
  return (
    <div className="screen center loading" role="status" aria-live="polite" data-testid="loading">
      <Logo height={44} />
      <span className="spinner" aria-hidden="true" />
      <p className="hint">{text}</p>
    </div>
  );
}
